import assign from 'lodash/assign';

import DispatchConstants from 'app/shared/constants/DispatchConstants';

const initState = () => ({
    clickCount: 0,
    leadCount: 0,
    viewCount: 0,
    daysOnMarketCount: 0,
    rows: [],
    propertyDetails: {},
});

const propertiesReport = (state = initState(), action = {}) => {
    const { type, payload } = action;

    switch (type) {
        case DispatchConstants.ANALYTICS_PROPERTIES_GET_SUCCESS:
            return assign({}, state, payload);

        case DispatchConstants.ANALYTICS_PROPERTIES_GET_FAIL:
            return state;

        default:
            return state;
    }
};

export default propertiesReport;
